import React, { FC } from 'react';

import { BUTTON_TYPES } from '@evinced-private/ui-common';

import { ScanCrawlStateHelper } from '../../helpers/ScanCrawlStateHelper';
import {
	getConfirmButtonText,
	getJobStatus,
	getPopupCancelMessage,
	getPopupCancelTitle
} from '../../helpers/ScanCrawlTextHelper';
import { IScan } from '../../interfaces/Scan';
import { useUserTenant } from '../../providers/userTenantProvider/UserTenantProvider';
import { JobStatusAction } from '../job-status-action/JobStatusAction';

import './PropertyJobsStatusAction.scss';

interface IPropertyJobsStatusActionProps {
	onDeleteScan: (id: string) => Promise<void>;
	lastScan?: IScan;
}

export const PropertyJobsStatusAction: FC<IPropertyJobsStatusActionProps> = ({
	lastScan,
	onDeleteScan
}) => {
	const { isReadOnlyUser } = useUserTenant();

	const onCancelScan = async (): Promise<void> => {
		await onDeleteScan(lastScan.id);
	};

	const isScanRunning = ScanCrawlStateHelper.isInProgress(lastScan?.state);

	if (!isScanRunning) {
		return null;
	}

	const getScanStatus = (): JSX.Element => {
		const title = getPopupCancelTitle('scan');
		const promptMessage = getPopupCancelMessage('scan');
		const confirmButtonText = getConfirmButtonText('scan');
		const jobsStatusText = getJobStatus('scan');
		return (
			<JobStatusAction
				popupTitle={title}
				confirmButtonText={confirmButtonText}
				jobsStatusText={jobsStatusText}
				onConfirm={onCancelScan}
				promptMessage={promptMessage}
				triggerButtonProps={{
					type: BUTTON_TYPES.SECONDARY,
					title: 'Cancel',
					children: 'Cancel'
				}}
				isPopupOpen={!isReadOnlyUser()}
			/>
		);
	};

	return (
		<div className="property-jobs-status-action">{isScanRunning ? getScanStatus() : null}</div>
	);
};
